import { IRootState } from '@bca-store/store.reducers';
import { createSelector } from '@ngrx/store';

export const selectTotalPrice = createSelector(
  ({ receipt }: IRootState) => receipt.totalPrice,
  ({ compose }: IRootState) => compose.totalPrice,
  (receiptPrice, composePrice) => receiptPrice + composePrice
);

export const selectAllProducts = createSelector(
  ({ receipt }: IRootState) => receipt.products,
  ({ compose }: IRootState) => compose.selectedProduct,
  (products, selectedProduct) => {
    return [selectedProduct, ...products]
      .filter(product => product != null)
      .sort((a, b) => (a.id > b.id ? 1 : -1));
  }
);

export const selectProductsWithUsers = createSelector(
  selectAllProducts,
  products => products.filter(product => product.user && product.user.valid)
);

export const selectIncompletedProducts = createSelector(
  selectAllProducts,
  products => products.filter(product => !product.user || (product.user && !product.user.valid))
);

export const selectUsers = createSelector(
  selectAllProducts,
  products => products.map(product => product.user).filter(user => user != null)
);

export const selectTotalProductCount = createSelector(
  selectAllProducts,
  products => products.length
);

export const selectUserId = createSelector(
  selectUsers,
  ({ companyData }: IRootState) => companyData.selectedCompany,
  (users, selectedCompany) => {
    if (selectedCompany) {
      const { representative } = selectedCompany;
      if (representative && users.some(user => user.id === representative.id)) {
        return representative.id;
      }
    }
    return users.length ? users[0].id : null;
  }
);

export const selectProductCount = createSelector(
  ({ receipt }: IRootState) => receipt.products,
  products => products.length
);

export const configuredProduct = createSelector(
  ({ compose }: IRootState) => compose.configuredProduct,
  configuredProduct => {
    return configuredProduct
  }
)
